import { useCallback } from 'react';
import {
  canAskSupportAssistant,
  SUPPORT_ASSISTANT_POLICY_REQUIRED,
} from 'utils/canAskSupportAssistant';
import { useAskSupportAssistantMutation } from './mutations/useAskSupportAssistantMutation';
import { useAiPolicyAcceptance } from './useAiPolicyAcceptance';
import { useSupportContext } from './useSupportContext';

export const useSupportAssistant = () => {
  const policy = useAiPolicyAcceptance();
  const context = useSupportContext();
  const [askMutation, askMutationResult] = useAskSupportAssistantMutation();

  const canChat = canAskSupportAssistant({
    policyLoading: policy.loading || !policy.acceptedCurrentPolicy,
    needsAcceptance: policy.needsAcceptance,
  });

  const ask = useCallback(
    async (message: string, conversationId?: string) => {
      if (!canChat) {
        throw new Error(SUPPORT_ASSISTANT_POLICY_REQUIRED);
      }
      return askMutation({
        variables: {
          input: {
            message,
            context,
            conversationId,
          },
        },
      });
    },
    [askMutation, canChat, context]
  );

  return {
    needsAcceptance: policy.needsAcceptance,
    policyText: policy.policyText,
    currentVersion: policy.currentVersion,
    acceptPolicy: policy.acceptPolicy,
    accepting: policy.accepting,
    acceptError: policy.acceptError,
    policyLoading: policy.loading,
    policyError: policy.error,
    retryPolicy: policy.refetch,
    canChat,
    context,
    ask,
    asking: askMutationResult.loading,
  };
};
